<template>
  <div class="app" :class="share == 1 ? 'p50' : ''">
    <div class="video">
      <video
        :src="playUrl"
        :poster="data.thumb"
        :controls="controls"
        :autoplay="autoplay"
      ></video>
      <div class="pos" v-show="showPoster">
        <van-image
          fit="cover"
          width="100%"
          height="100%"
          :src="data.thumb"
          alt=""
        />
      </div>
      <i
        v-show="showPoster"
        class="iconfont icon-bofang play"
        @click="palyVideo"
      ></i>
    </div>
    <div class="video-d">
      <div class="video-l">
        <div class="video-title">{{ data.title }}</div>
        <div class="price" v-if="data.type == 1">
          ￥<span>{{ data.price }}</span>
        </div>
        <div class="price" style="color: #36dc7e" v-else>【免费】</div>
      </div>
      <div class="collection" @click="collection">
        <img
          src="../../../assets/home/inCollection.png"
          v-show="data.isCollection"
        />
        <img
          src="../../../assets/home/collection.png"
          v-show="!data.isCollection"
        />
        <p class="collection-num">{{ data.read_num }}</p>
      </div>
    </div>

    <div class="content">
      <div class="nav-tab">
        <div
          :class="{ action: item.id == current }"
          v-for="(item, index) in tabs"
          :key="index"
          @click="current = item.id"
        >
          {{ item.title }}
          {{
            item.id == 3
              ? data.commentNum
                ? `(${data.commentNum})`
                : "(0)"
              : ""
          }}
        </div>
      </div>

      <div class="nav-tab-c" v-show="current == 1">
        <div
          class="catalogue"
          v-for="(item, index) in data.catalog"
          :key="index"
        >
          <template v-if="item.type == 1">
            <div class="catalogue-title">
              <div class="catalogue-title-line"></div>
              <div>
                {{ item.title }}
              </div>
            </div>
            <template v-if="item.list.length">
              <div
                class="catalogue-kc"
                v-for="(ch, i) in item.list"
                :key="i"
                @click="clickCatalog(ch)"
              >
                <div class="catalogue-kc-spot"></div>
                <div :class="clickIndex == ch.id ? 'grcolor' : ''">
                  {{ ch.title }}
                  <span v-if="ch.see == 1" style="color: #ff8a00"
                    >【付费】</span
                  >
                </div>
              </div>
            </template>
          </template>

          <div
            class="catalogue-kc"
            v-if="item.type == 0"
            @click="clickCatalog(item)"
          >
            <div class="catalogue-kc-spot"></div>
            <div :class="clickIndex == item.id ? 'grcolor' : ''">
              {{ item.title }}
              <span v-if="item.see == 1" style="color: #ff8a00">【付费】</span>
            </div>
          </div>
        </div>

        <div class="buy-box" v-if="data.type == 1">
          <div class="buton buy" v-if="!data.isBuy" @click="bayVideo">
            立即购买
          </div>
        </div>
      </div>
      <div class="nav-tab-c" v-show="current == 2">
        <div v-html="deatils"></div>
      </div>
      <div class="nav-tab-c" v-show="current == 3">
        <comment :list="commentList" :state="false" :tabshow="true" />
      </div>
    </div>

    <div class="edit-btn" @click="changeInput" v-show="current == 3">
      <i class="iconfont icon-bi"></i>
    </div>
    <div class="send-input" v-show="showInput">
      <div>
        <div class="text-box">
          <input
            ref="inp"
            type="text"
            v-model="sendText"
            placeholder="请输入评论"
          />
        </div>
        <div
          class="send"
          v-show="sendText"
          @mousedown.prevent
          @click.stop="communityComment"
        >
          发送
        </div>
      </div>
    </div>
    <shareBottomComp v-if="share == 1"></shareBottomComp>
  </div>
</template>

<script>
/**
@description:课程详情
@createTime:2021-08-20
@create:wq
*/
import { formatRichText } from "../../../utils/tool";
import comment from "../../../components/comment.vue";
import shareBottomComp from "@/components/shareBottomComp";
import { shareJsSdk, HERF, getQueryString } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: { comment, shareBottomComp },
  data() {
    return {
      current: 2,
      tabs: [
        { id: 2, title: "详情" },
        { id: 3, title: "评论" },
      ],
      id: "",
      deatils: "",
      data: "",
      commentList: [],
      playUrl: "",
      controls: false,
      autoplay: false,
      showPoster: true,
      showInput: false,
      sendText: "",
      clickIndex: 0,
      share: 0,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    let id = this.$route.query.id ? this.$route.query.id : getQueryString("id");
    if (getQueryString("share")) {
      this.share = 1;
    } else {
      this.share = 0;
    }
    if (this.$route.query && id) {
      this.id = id;
      this.getData();
      this.getComment();
    }
  },
  methods: {
    changeInput() {
      this.showInput = true;
      this.$nextTick(() => {
        this.$refs.inp.focus();
        this.$refs.inp.onblur = () => {
          // setTimeout(() => {
          this.showInput = false;
          // }, 100);
        };
      });
    },
    //评论
    communityComment() {
      this.api
        .curriculumComment({
          id: this.id,
          title: this.sendText,
        })
        .then(() => {
          this.$refs.inp.focus();
          this.getComment();
          this.data.commentNum++;
          this.showInput = false;
          this.sendText = "";
        });
    },
    palyVideo() {
      this.Toast("请选择你要播放的视频");
    },
    clickCatalog(item) {
      if (item.see == 1 && !this.data.isBuy) {
        this.Toast("请先购买，再播放视频");
      } else {
        if (item.url) {
          this.clickIndex = item.id;
          console.log(this.clickIndex, "index");
          this.playUrl = item.url;
          this.autoplay = true;
          this.controls = true;
          this.showPoster = false;
        } else {
          this.Toast("没有可播放的视频");
        }
      }
    },
    getData() {
      this.api.curriculumDetails({ id: this.id }).then((res) => {
        this.data = res.data;
        console.log(this.data.catalog);
        this.deatils = formatRichText(res.data.content);
        this.tabs.unshift({ id: 1, title: "目录" });
        this.playUrl = res.data.url;
        this.autoplay = true;
        this.controls = true;
        this.showPoster = false;
        //付费才有目录
        // if (res.data.type == 1) {
        //   this.tabs.unshift({ id: 1, title: "目录" });
        // } else {
        //   this.playUrl = res.data.url;
        //   this.autoplay = true;
        //   this.controls = true;
        //   this.showPoster = false;
        // }
        shareJsSdk('kcdetails',this.data.title,'',this.id,this.data.thumb)
      });
    },
    getComment() {
      this.api.curriculumCommentList({ id: this.id }).then((res) => {
        this.commentList = res.data.data;
      });
    },
    collection() {
      this.api.CollectionCourses({ id: this.id }).then(() => {
        if (this.data.isCollection) {
          this.data.isCollection = false;
          this.Toast.success("取消收藏");
          this.data.read_num--;
        } else {
          this.data.isCollection = true;
          this.Toast.success("收藏成功");
          this.data.read_num++;
        }
      });
    },
    bayVideo() {
      localStorage.setItem("order", JSON.stringify(this.data));
      this.$router.push({ path: "orderConfirm", query: { s: 3 } });
    },
  },
};
</script>
<style lang="scss" scoped>
.app {
  padding-bottom: 100px;
}
.video {
  width: 100%;
  height: 4.14rem;
  background: #000000;
  position: relative;
  video {
    width: 100%;
    height: 100%;
  }
  .pos {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: #cccccc;
  }
  .play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 40px;
  }
}
.video-d {
  height: 1.32rem;
  display: flex;
  align-items: center;
  padding: 0 0.24rem;
  border-bottom: 0.12rem solid #f1f1f1;
  .video-l {
    flex: 1;
    .video-title {
      font-size: 0.28rem;
      font-weight: 400;
      color: #333333;
    }
    .price {
      color: #f05468;
      font-size: 0.24rem;
      margin-top: 3px;
      span {
        font-size: 0.32rem;
        font-weight: 400;
      }
    }
  }
  .collection {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 0.45rem;
    }
    .collection-num {
      font-size: 0.24rem;
      font-weight: 400;
      color: #cccccc;
      text-align: center;
      margin-top: 3px;
    }
  }
}

.content {
  margin: 0 0.24rem;
  .nav-tab {
    margin: 0.2rem 0;
    height: 40px;
    background: #f5f5f5;
    border-radius: 20px;
    font-size: 15px;
    font-weight: 400;
    color: #999999;

    display: flex;
    > div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .action {
      background: #4fd9d5;
      border-radius: 20px;
      box-shadow: 0 3px 6px rgba($color: #4fd9d5, $alpha: 0.3);
      color: #ffffff;
    }
    .nav-tab-c {
      margin-top: 0.54rem;
    }
  }

  .catalogue {
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 0.44rem;
    }
    .catalogue-title {
      font-size: 0.36rem;
      font-weight: 400;
      color: #333333;
      align-items: flex-start;

      .catalogue-title-line {
        width: 0.08rem;
        height: 0.34rem;
        background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
        border-radius: 0px 0.04rem 0.04rem 0px;
        margin-right: 0.28rem;
      }
    }
    .catalogue-kc {
      margin-left: 0.6rem;
      font-size: 0.3rem;
      font-weight: 400;
      color: #333333;
      .catalogue-kc-spot {
        width: 0.12rem;
        height: 0.12rem;
        background: #4fd9d5;
        border-radius: 50%;
        margin-right: 0.18rem;
      }
    }
  }
}
.buy-box {
  height: 60px;
}
.buy {
  // width: 702px;
  // height: 40px;
  // background: #4fd9d5;
  box-shadow: 0px 3px 6px rgba(79, 217, 213, 0.3);
  // opacity: 1;
  border-radius: 20px;
  position: fixed;
  bottom: 10px;
  left: 0.24rem;
  right: 0.24rem;
}
.edit-btn {
  background: #4fd9d5;
  position: fixed;
  bottom: 60px;
  right: 10px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px #4fd9d5;
  i {
    color: white;
    font-size: 18px;
  }
}
.send-input {
  width: 100%;
  height: 50px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background: #f2f2f2;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    width: 95%;
    height: 35px;

    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .text-box {
    padding: 0 10px;
    flex: 1;
    height: 100%;
    border-radius: 20px;
    background: #ffffff;
    overflow: hidden;
    input {
      border: none;
      outline: none;
      width: 100%;
      height: 100%;
    }
  }
  .send {
    margin-left: 10px;
    background: #4fd9d5;
    font-size: 16px;
    height: 30px;
    color: #ffffff;
    border-radius: 5px;
    line-height: 30px;
    padding: 0 10px;
  }
}
.grcolor {
  color: #4fd9d5;
}
</style>
